import React, { useContext } from "react";
import { Row, Col, Card, Button, Table } from "react-bootstrap";
import classes from "./TableReceipt.module.css";
import { Divider } from "rsuite";
import PermissionContext from "../../Store/permission-context";
const Receipt = (props) => {
  const PCtx = useContext(PermissionContext);
  const inWords = (number) => {
    var digit = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    var elevenSeries = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    var countingByTens = [
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    var shortScale = ["", "Thousand", "Million", "Billion", "Trillion"];

    number = number.toString();
    number = number.replace(/[\, ]/g, "");
    if (number != parseFloat(number)) return "Not a Number";
    var x = number.indexOf(".");
    if (x == -1) x = number.length;
    if (x > 15) return "Too Big";
    var n = number.split("");
    var str = "";
    var sk = 0;
    for (var i = 0; i < x; i++) {
      if ((x - i) % 3 == 2) {
        if (n[i] == "1") {
          str += elevenSeries[Number(n[i + 1])] + " ";
          i++;
          sk = 1;
        } else if (n[i] != 0) {
          str += countingByTens[n[i] - 2] + " ";
          sk = 1;
        }
      } else if (n[i] != 0) {
        str += digit[n[i]] + " ";
        if ((x - i) % 3 == 0) str += "hundred and ";
        sk = 1;
      }
      if ((x - i) % 3 == 1) {
        if (sk) str += shortScale[(x - i - 1) / 3] + " ";
        sk = 0;
      }
    }
    if (x != number.length) {
      var y = number.length;
      str += "point ";
      for (var i = x + 1; i < y; i++) str += digit[n[i]] + " ";
    }
    str = str.replace(/\number+/g, " ");

    str = str.trim() + " Naira";
    var right = "hundred Naira";
    var wrong = "hundred and Naira";
    str = str.indexOf(wrong) >= 0 ? str.replace(wrong, right) : str;
    return str;
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} className={classes.margin4printing}>
        <Row className={classes.MyReceipt}>
          <Col md={12} sm={12}>
            <p className={classes.Company}>APPLAUSE SUPERMARKET AND STORES</p>
            <p className={classes.Address} style={{ fontStyle: "italic" }}>
              Wholesales & Retails
            </p>
            <p className={classes.Address}>No 9, Phase 5A, Mabolaje, Oyo..</p>
            <p className={classes.Tel}>08033824233</p>
            <Divider style={{ margin: "10px", fontFamily: "Times New Roman" }}>
              PAYMENT RECEIPT
            </Divider>
          </Col>
        </Row>

        {props.Rct.ShowReceipt && (
          <Row className={classes.MyReceipt}>
            <Col md={12} sm={12}>
              <Row className="px-2">
                <Col md={12} sm={12} className={classes.ReceiptName}>
                  Name: {props.Rct.cn}
                </Col>
                <Col md={7} sm={7} xs={7} className={classes.ReceiptDetails}>
                  Receipt No : {props.Rct.rcn}
                </Col>
                <Col md={5} sm={5} xs={5} className={classes.ReceiptDetails}>
                  Phone: {props.Rct.pn}
                </Col>
                <Col md={7} sm={7} xs={7} className={classes.ReceiptDetails}>
                  Date: {props.Rct.rdt}
                </Col>
                <Col md={5} sm={5} xs={5} className={classes.ReceiptDetails}>
                  Staff: {PCtx.UserId}
                </Col>
              </Row>
            </Col>
            <Divider className="mr-1 my-1" />

            <Table bordered className={classes.TheTable}>
              <thead>
                <tr className={classes.TableDataPrice}>
                  <th className={classes.TableDataPrice}>SN</th>
                  <th className={classes.TableDataPrice}>Description</th>
                  <th className={classes.TableDataPrice}>Unit Price</th>
                  {/* <th className={classes.TableData}>B/U</th> */}
                  <th className={classes.TableDataPrice}>Sub Total</th>
                </tr>
              </thead>
              <tbody>
                {props.Rct.OrderData.map((order, index) => (
                  <tr key={index} className={classes.TableData}>
                    <td className={classes.TableData}>{index + 1}</td>
                    <td className={classes.TableData}>{order.description}</td>
                    <td className={classes.TableDataPrice}>
                      {order.nou > 0 ? order.unitprice : "-"}
                    </td>
                    {/* <td className={classes.TableData}>{order.converter}</td> */}
                    <td className={classes.TableDataPrice}>{order.subtotal}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Col md={12} sm={12} xs={12}>
              {props.Rct.Discount > 0 && (
                <p className={classes.Discount}>
                  Discount Given: {props.Rct.Discount}{" "}
                </p>
              )}
              <p className={classes.Total}>
                Total Amount Paid: ₦
                {props.Rct.PaymentMode === "Credit"
                  ? 0
                  : props.Rct.PayableWithDiscount}
              </p>
              <p className={classes.Word}>
                {props.Rct.PaymentMode === "Credit"
                  ? "Bought on Credit"
                  : inWords(parseFloat(props.Rct.PayableWithDiscount))}
              </p>
              <Divider className="mr-1 my-1" />
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p className={classes.TenderChange}>
                Tender: ₦{props.Rct.Tender}
              </p>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p className={classes.TenderChange}>
                Change Given: ₦{props.Rct.ChangeCollected}
              </p>
            </Col>
            <Divider className="mr-1 my-1" />
            <Col lg={12} md={12} sm={12} xs={12}>
              <p className={classes.Word}>
                Goods sold in good condition are not returnable.
              </p>
              <p className={classes.Word}>Thanks for your patronage</p>
              <Divider className="mr-1 my-1" />
            </Col>
            <Col md={12} sm={12} xs={12}>
              <p className={classes.Applause}>
                POS Software developed by:
                <br />
                APPLAUSE INFOTECH | 08033824233
              </p>
            </Col>
          </Row>
        )}
      </Col>
      <Col
        md={12}
        sm={12}
        xs={12}
        className={`${classes.hide4printing} ${"mt-2"}`}
      >
        <Button variant="success" className="w-100" onClick={window.print}>
          Print Receipt
        </Button>
      </Col>
    </Row>
  );
};

export default Receipt;
